<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>{{ $t("menu.applicant_info") }}</v-card-title>
          <v-divider color="white"></v-divider>
          <br />
          <UserInfoCard
            :value_prenameId="UserInfo_prenameId"
            @input_prenameId="UserInfo_prenameId = $event"
            :value_nameTh="UserInfo_nameTh"
            @input_nameTh="UserInfo_nameTh = $event"
            :value_surnameTh="UserInfo_surnameTh"
            @input_surnameTh="UserInfo_surnameTh = $event"
            :value_nameEn="UserInfo_nameEn"
            @input_nameEn="UserInfo_nameEn = $event"
            :value_surnameEn="UserInfo_surnameEn"
            @input_surnameEn="UserInfo_surnameEn = $event"
            :value_thaiOrOtherNation="UserInfo_thaiOrOtherNation"
            @input_thaiOrOtherNation="UserInfo_thaiOrOtherNation = $event"
            :value_nationId="UserInfo_nationId"
            @input_nationId="UserInfo_nationId = $event"
            :value_citizenId="UserInfo_citizenId"
            @input_citizenId="UserInfo_citizenId = $event"
            :value_mobile="UserInfo_mobile"
            @input_mobile="UserInfo_mobile = $event"
            :value_email="UserInfo_email"
            @input_email="UserInfo_email = $event"
            :value_birthday="UserInfo_birthday"
            @input_birthday="UserInfo_birthday = $event"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import UserInfoCard from "@/components/info_cards/UserInfo";
import ApplicantInfoProvider from "@/services/applicant_info";
import authfoProvider from "@/services/auth.provider";

const applicantInfoService = new ApplicantInfoProvider();
const authService = new authfoProvider();

export default {
  name: "ApplicantInfoGeneral",
  data: function () {
    return {
      loading: false,
      form_validate_status: null,

      UserInfo_prenameId: null,
      UserInfo_nameTh: null,
      UserInfo_surnameTh: null,
      UserInfo_nameEn: null,
      UserInfo_surnameEn: null,
      UserInfo_thaiOrOtherNation: null,
      UserInfo_nationId: null,
      UserInfo_citizenId: null,
      UserInfo_mobile: null,
      UserInfo_email: null,
      UserInfo_birthday: null,
    };
  },

  components: {
    UserInfoCard,
  },

  methods: {
    async fetch_data() {
      // await this.$store.dispatch("auth/getSidebarStatus");
      const uid = localStorage.getItem("uid");
      const data = await authService.getUserInfo(uid);
      this.UserInfo_citizenId = data.admission.CITIZEN_ID;
      this.UserInfo_nationId = data.admission.NATION_ID;
      this.UserInfo_email = data.admission.EMAIL;
      this.UserInfo_mobile = data.admission.MOBILE;
      this.UserInfo_prenameId = data.admission.PREFIX_NAME_ID;
      this.UserInfo_nameEn = data.admission.STUDENT_FNAME_EN;
      this.UserInfo_nameTh = data.admission.STUDENT_FNAME_TH;
      this.UserInfo_surnameEn = data.admission.STUDENT_LNAME_EN;
      this.UserInfo_surnameTh = data.admission.STUDENT_LNAME_TH;
      this.UserInfo_birthday = data.admission.BIRTHDAY;

      if (data.admission.NATION_ID === "TH") {
        this.UserInfo_thaiOrOtherNation = "thai";
      } else if (
        data.admission.NATION_ID &&
        data.admission.NATION_ID.length === 2
      ) {
        this.UserInfo_thaiOrOtherNation = "other";
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      const uid = localStorage.getItem("uid");
      const response = await applicantInfoService
        .setApplicantInfoGeneral(
          {
            CITIZEN_ID: this.UserInfo_citizenId,
            CREATE_USER_ACCOUNT_AS_INTER:
              this.UserInfo_thaiOrOtherNation === "other",
            NATION_ID:
              this.UserInfo_thaiOrOtherNation === "thai"
                ? "TH"
                : this.UserInfo_nationId,
            EMAIL: this.UserInfo_email,
            GENDER_ID: "-",
            MOBILE: this.UserInfo_mobile,
            PREFIX_NAME_ID: this.UserInfo_prenameId,
            STUDENT_FNAME_EN: this.UserInfo_nameEn,
            STUDENT_FNAME_TH: this.UserInfo_nameTh,
            STUDENT_LNAME_EN: this.UserInfo_surnameEn,
            STUDENT_LNAME_TH: this.UserInfo_surnameTh,
            BIRTHDAY: this.UserInfo_birthday,
          },
          uid
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status) {
        this.$store.dispatch("auth/getUserInfo");
        this.$toasted.success(this.$t("toasted.save_successfully"));
      } else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_data();
      this.loading = false;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
